import React from "react";
import Table from "sulu-admin-bundle/components/Table";
import headerStyles from "../../css/table/RecapList.scss";
import cellStyles from "../../css/table/RowCell.scss";
import SimpleHeaderCell from "../components/Table/SimpleHeaderCell";
import RecapLegend from "../components/Table/RecapLegend";
import { renderMatchStatus } from "../components/Table/matchStatusUtils";
import Moment from "moment";
import tableStyles from "../../css/table/TableStyles.scss";
import Button from "sulu-admin-bundle/components/Button";

import { ResourceRequester } from "sulu-admin-bundle/services";

import Modal from "../components/CustomList/PassportModal";

class RecapList extends Table<Props> {
    constructor(props) {
        super(props);

        this.locale = this.props.router.attributes.locale;

        this.state = {
            isPassportModalOpen: false,
            passportItem: "",
        };
    }

    navigateToPlayerDetail = (contactId) => {
        const isStaff = this.props.label === 'dhbStaffRecaps';
        this.props.router.navigate(isStaff ? 'app.staff_recap_detail' : 'app.player_recap_detail', {
            id: contactId,
            locale: this.locale,
            seasonId: this.props.data.seasonId,
            teamId: this.props.router.attributes.id,
            fromView: this.props.router.route.name,
        });
    };

    openPassportModal = (playerId) => {
        const allPlayers = Object.values(this.props.data.allTeamPlayers);
        const selectedPlayer = allPlayers.find(
            (player) => player.contact === playerId
        );

        this.setState({
            isPassportModalOpen: true,
        });

        ResourceRequester.get("dhbpassports", {
            locale: this.locale,
            id: selectedPlayer?.passport,
        })
            .then((data) => {
                if (data) {
                    this.setState({
                        passportItem: data,
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    passportItem: {
                        error: error.statusText,
                    },
                });
                console.log(error);
            });
    };

    closePassportModalHandler = () => {
        this.setState({
            isPassportModalOpen: false,
            passportItem: "",
        });
    };

    renderHeaderCells = (header, headerCount, matchDays) => {
        return header.map((headerCell, index) => {
            if (index === 0) {
                return (
                    <SimpleHeaderCell
                        className={headerStyles.simpleHeaderCell}
                        key={index}
                    >
                        {headerCell}
                    </SimpleHeaderCell>
                );
            } else if (index === 1) {
                return (
                    <SimpleHeaderCell key={index}>
                        {headerCell}
                    </SimpleHeaderCell>
                );
            } else if (index > 1 && index < headerCount) {
                return (
                    <SimpleHeaderCell
                        className={headerStyles.simpleHeaderCell}
                        key={index}
                    >
                        {headerCell}
                    </SimpleHeaderCell>
                );
            } else {
                const game = matchDays[headerCell]?.game;
                const tooltipLineOne = Moment(game?.schedule).format(
                    "D[.] MMMM YYYY"
                );
                const tooltipLineTwo = `${game?.homeTeam} vs ${game?.awayTeam} (${game?.result})`;
                const tooltip = `${tooltipLineOne}<br/>${tooltipLineTwo}`;
                const headerText = index - (headerCount - 1);

                return (
                    <SimpleHeaderCell
                        className={headerStyles.simpleHeaderCell}
                        dataTitle={tooltip}
                        key={index}
                    >
                        {"#" + headerText}
                    </SimpleHeaderCell>
                );
            }
        });
    };

    renderRows = (rows) => {
        return rows.map((row, rowIndex) => {
            return (
                <Table.Row key={row[0]} rowIndex={row[0]} expanded isLoading>
                    {Object.values(row).map((cell, index) =>
                        this.renderCellEvent(cell, index, rowIndex, row)
                    )}
                </Table.Row>
            );
        });
    };

    renderCellEvent = (cell, index, rowIndex, row) => {
        const Cell = Table.Cell;
        let element = "";

        if (index === 0) {
            element = rowIndex + 1;
        } else if (index === 1) {
            // Player/staff name — navigates to player detail
            if (["dhbPlayerRecaps", "dhbStaffRecaps"].includes(this.props.label)) {
                element = (
                    <Button
                        skin="link"
                        onClick={() => this.navigateToPlayerDetail(row[0])}
                    >
                        {cell}
                    </Button>
                );
            } else {
                element = cell;
            }
        } else if (index === 2) {
            // Passport number — opens passport modal (original behaviour)
            if (this.props.label === "dhbPlayerRecaps") {
                element = (
                    <Button
                        skin="link"
                        onClick={() => this.openPassportModal(row[0])}
                    >
                        {cell}
                    </Button>
                );
            } else {
                element = renderMatchStatus(cell);
            }
        } else if (index === 3) {
            const playedGames = Object.values(row)
                .slice(4)
                .filter((elem) => elem !== undefined && elem !== "ETW").length;
            element = cell === "S2"
                ? renderMatchStatus("S2", { postText: `${playedGames}sp`, className: cellStyles.shirtField }) : renderMatchStatus(cell);
        } else {
            element = renderMatchStatus(cell);
        }

        return (
            <Cell key={index} className={cellStyles.recapCell}>
                {element}
            </Cell>
        );
    };

    render() {
        const Header = Table.Header;
        const Body = Table.Body;

        const dataPath = this.props.dataPath.replace(/\//g, "");

        const { header, rows, matchDays } = this.props.data[dataPath];
        const headerCount = header.findIndex((element) => !isNaN(element));

        return (
            <div className={tableStyles.recapTableWrap}>
                <Table skin="dark">
                    <Header
                        allSelected={false}
                        selectInFirstCell={false}
                        skin="dark"
                    >
                        {this.renderHeaderCells(header, headerCount, matchDays)}
                    </Header>
                    <Body selectInFirstCell={false}>
                        {this.renderRows(rows)}
                    </Body>
                </Table>
                <div className={tableStyles.legendWrap}>
                    <RecapLegend />
                </div>
                <Modal
                    isOpen={this.state.isPassportModalOpen}
                    closeHandler={this.closePassportModalHandler}
                    passportItem={this.state.passportItem}
                    locale={this.locale}
                />
            </div>
        );
    }
}

export default RecapList;
